import { gql } from 'graphql-request'

export const EXCLUIR_ITEM = gql`
  mutation ExcluirItemMutation($idItem: ID!) {
    excluirItemBiblioteca(idItem: $idItem) {
      id
      pastaPai {
        id
      }
    }
  }
`
